import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { useWidgetEdit } from "./WidgetEditContext";

interface WidgetShellProps {
  title: string;
  action?: ReactNode;
  children: ReactNode;
}

export function WidgetShell({ title, action, children }: WidgetShellProps) {
  const { isEdit, cardTitle, editRight, renaming, renameInput } = useWidgetEdit();
  const displayTitle = cardTitle ?? title;

  return (
    <div className="flex flex-col h-full">
      <div
        className={cn(
          "shrink-0 flex flex-col gap-2.5 px-4 pt-4 pb-3 border-b border-border/60 select-none",
          isEdit && "cursor-grab active:cursor-grabbing drag-handle",
        )}
      >
        <div className="flex items-center justify-between gap-2">
          {renaming ? (
            renameInput
          ) : (
            <span className="flex-1 text-base font-normal text-primary truncate">
              {displayTitle}
            </span>
          )}

          {action && (
            <div onMouseDown={isEdit ? (e) => e.stopPropagation() : undefined}>{action}</div>
          )}

          {isEdit && editRight}
        </div>
      </div>

      <div className="flex-1 min-h-0 flex flex-col">{children}</div>
    </div>
  );
}
